import React from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators as authActions } from "../../state/ducks/auth";
import { classNames } from "../../utils/common";
import Logo from "../Logo";

/**
 * Handles the form submit
 *
 * @param {Function} dispatch - the dispatch function available in the Redux store
 * @returns {Function}
 */
function onSubmit(dispatch) {
  return async function (data) {
    dispatch(authActions.kbportLogin(data.email, data.password));
  };
}

/**
 *
 * @param {String} error - the error message
 * @returns {String,undefined} - the HTML markup if error message is defined; undefined otherwise
 */
function renderError(error) {
  if (error) {
    return (
      <div
        className="bg-gray-200 border-b-4 border-secondary text-secondary px-4 py-3 mx-1 mt-2 shadow-inner"
        role="alert"
      >
        <div className="flex">
          <svg
            className="fill-current h-6 w-6 text-secondary mr-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
          </svg>
          <div>
            <p className="font-bold">{error}</p>
          </div>
        </div>
      </div>
    );
  }
}

function LoginForm() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { register, handleSubmit } = useForm();

  return (
    <div className="flex items-center justify-center h-screen w-screen bg-signal">
      <div className="w-5/6 sm:w-2/3 lg:w-1/3 p-5 lg:py-8 bg-primary-dark shadow-2xl">
        <Logo className="w-2/3 mx-auto" />

        <form className="mt-2" onSubmit={handleSubmit(onSubmit(dispatch))}>
          {auth && auth.error && renderError(auth.error.error_description)}
          <div className="flex flex-col sm:flex-row lg:flex-col">
            <div className="form-element">
              <label className="form-label" htmlFor="email">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                ref={register}
                className="form-input"
                autoComplete="email"
                required
              />
            </div>
            <div className="form-element">
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                ref={register}
                className="form-input"
                required
              />
            </div>
          </div>
          <div className="flex">
            <div className={classNames("form-element self-end", "w-full mt-6")}>
              <input className="form-btn" type="submit" value="Enter" />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginForm;
